import { RecordLoader } from "MODULES/shared/containers";
import { connect } from "react-redux";

export default function connectRecord(options) {
  return connect(
    (state, ownProps) => ({
      record: (state[options.reducer] || state[options.name]).get(options.name),
      id: ownProps.match.params.id
    }),
    { fetch: options.action }
  )(RecordLoader);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/connectRecord.js